<template>
  <div id="app">
    <div class="container">
      <transition name="route" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      languages: {},
      isShowVisible: false,
    };
  },

  methods: {
    showVisible() {
      this.isShowVisible = true;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter&display=swap");

/*Route transitions -start */
.route-enter {
  opacity: 0;
  transform: translateX(100px);
}
.route-enter-active {
  transition: all 0.3s ease-out;
}

.route-leave-to {
  opacity: 0;
  transform: translateX(-100px);
}
.route-leave-active {
  transition: all 0.3s ease-in;
}
/*Route transitions -ends */

#app {
  /* min-height: 100%;
  font-family: "fira400";
  font-size: 18px;
  color: black;
  margin-top: 15px; */
  font-family: "OpenSans-Medium";
  background: url("./assets/images/bg_first.png") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  font-size: 16px;
  margin: 0;
  /* height: 100%; */
  min-height: 100vh;
  max-height: 100%;
  overflow: hidden;
}
.background-image1 {
  position: absolute;
  top: 1%;
  left: -10%;
  z-index: -1;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-attachment: fixed;

}
.gray_font {
  color: #636363 !important;
  font-size: 17px;
  line-height: 23.92px;
  font-weight: 300;
}

.area {
  width: 100%;
  padding: 5px;
  background: #f9f9f9;
  border: 1px solid #1b1b1b;
  border-radius: 31px;
}
.line {
  border-right: 1px solid black;
}
.items {
  background-color: gainsboro;
  padding: 4px 12px;
  border-radius: 26px;
  margin: 6px 4px;

  max-width: fit-content;
  display: inline-block;
}

.background-image2 {
  position: absolute;
  top: -8%;
  left: -1%;
  transform: rotate(180deg);
  z-index: -1;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-attachment: fixed;
}
.background-image4 {
  position: absolute;
  top: 1%;
  left: -10%;
  transform: rotate(1deg);
  z-index: -1;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-attachment: fixed;
}
.specipic-style {
  letter-spacing: 1.8px;
  font-family: "OpenSans-Medium";
}

.specific-line {
  font-size: 1.6rem;
  letter-spacing: 1px;
  font-family: "OpenSans-Medium";
  line-height: 2rem;
}
.specific-sentance {
  font-family: "OpenSans-Medium";
}

.preview-page-title {
  font-family: "OpenSans-Medium";
  color: #009ec2;
  font-size: 1.2rem;
  font-weight: bold;
}

.specific {
  text-align: center;
  margin-top: 5%;
  line-height: 18px;
}
.date-picking i::before {
  color: #009ec2 !important;
}

/* logo_part */
.img-after::after {
  content: "";
  position: absolute;
  width: 85%;
  height: 1px;
  background: #009ec2;
  left: 13.8%;
  margin-top: 5%;
}
.Lang_Select {
  position: absolute;
  left: 91%;
  bottom: 20%;
  margin-top: -6.5%;
}
.back_arrow {
  position: absolute;
  left: 87%;
  bottom: 20%;
  margin-top: -7.5%;
}
.nsb_kyc_logo {
  width: 13%; /*7% */
  margin-top: 1%;
  height: 90%;
}
@media only screen and (max-width: 682px) {
  .Lang_Select {
    position: absolute;
    left: 78%; /*78% */
    top: 60%; /*60% */
  }
  .nsb_kyc_logo {
    width: 30%; /*10% */
    height: 4vh;
    margin-left: 1%;
  }
  .img-after::after {
    margin-top: 9%; /*8% */
    left: 30.5%; /*12% */
    width: 68%; /*86% */
  }
}
/* logo_part */

/* continue and back button */
.back-button-en {
  border: none !important;
  font-size: 1rem;
  background-color: #d9d9d9 !important;
  padding-inline: 10% !important;
  margin-right: 10px !important;
}
.back-button-si {
  border: none !important;
  font-size: 1rem;
  background-color: #d9d9d9 !important;
  padding-inline: 6% !important;
  margin-right: 10px !important;
}
.back-button-ta {
  border: none !important;
  font-size: 1rem;
  background-color: #d9d9d9 !important;
  padding-inline: 6% !important;
  margin-right: 10px !important;
}
.back-button:hover {
  box-shadow: 2px;
}
.resend-button {
  border: none !important;
  font-size: 1rem;
  background-color: #d9d9d9 !important;
  padding-inline: 10% !important;
  margin-right: 10px !important;
}
.reject-button {
  border: none !important;
  font-size: 1rem;
  background-color: #d9d9d9 !important;
  padding-inline: 5% !important;
  margin-right: 10px !important;
}
.continue-button-en {
  padding-inline: 15% !important;
}
.continue-button-si {
  padding-inline: 4% !important;
}
.continue-button-ta {
  padding-inline: 10% !important;
}
.agree-button {
  padding-inline: 8% !important;
}
/* continue and back button */
/*showcontant*/
.showcontant {
  color: #009ec2;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
  letter-spacing: 1px;
}
.showcontant:hover {
  text-shadow: 0.5px #009ec2;
  font-weight: bold;
}
/*show*/

.links:hover {
  text-shadow: 0.5px #219dd9;
  font-weight: bold;
  cursor: pointer;
}

.label {
  font-family: "OpenSans-SemiBold";
  font-size: 1.2rem !important;
  font-weight: 500 !important;
  letter-spacing: 0.3px !important;
}
label {
  font-family: "OpenSans-SemiBold";
  font-size: 1.2rem !important;
  font-weight: 500 !important;
  letter-spacing: 0.3px !important;
}
.en-line {
  letter-spacing: 1.8px;
  font-size: 3rem;
  font-family: "OpenSans-Medium";
  line-height: 40px;
}
.si-line {
  font-size: 2.7rem;
  font-weight: 600;
  word-spacing: 7px;
  line-height: 55px;
}
.en-he-line {
  letter-spacing: 1px;
  font-size: 3rem;
  font-family: "OpenSans-Medium";
  line-height: 45px;
}
.si-he-line {
  font-size: 2.7rem;
  font-weight: 600;
  word-spacing: 7px;
  line-height: 55px;
}
.si-he-specific-line {
  font-size: 2.1rem;
  font-weight: 600;
  word-spacing: 7px;
  line-height: 48px;
}

.en-sub-line {
  font-size: 1.6rem;
  letter-spacing: 1px;
  font-family: "fira500";
  line-height: 2rem;
}
.si-sub-line {
  font-size: 1.4rem;
  font-weight: 600;
  word-spacing: 3px;
  line-height: 2rem;
}
.ta-line {
  letter-spacing: 0.5px;
  font-size: 2.5rem;
}
.si-label {
  font-weight: 550;
  font-size: 1rem !important;
  letter-spacing: 0px !important;
  word-spacing: 7px;
}
.ta-label {
  font-weight: 600;
  letter-spacing: 0px !important;
}

.textarea {
  font-family: "Inter", sans-serif;
  font-size: 8rem;
  font-weight: 400;
}
/* get help */
.get-help {
  position: fixed;
  top: 78%;
  left: 90%;
  cursor: pointer;
}
.gethelp_image {
  width: 60%;
} /* get help */
/* model */
.modal-close-button {
  position: absolute;
  right: 1%;
}
/*font family*/
@font-face {
  font-family: "OpenSans-SemiBold";
  src: url(../src/assets/fonts/OpenSans-SemiBold.ttf);
}
@font-face {
  font-family: "OpenSans-Bold";
  src: url(../src/assets/fonts/OpenSans-Bold.ttf);
}
@font-face {
  font-family: "OpenSans-ExtraBold";
  src: url(../src/assets/fonts/OpenSans-ExtraBold.ttf);
}
@font-face {
  font-family: "OpenSans-Medium";
  src: url(../src/assets/fonts/OpenSans-Medium.ttf);
}
@font-face {
  font-family: "OpenSans-Regular";
  src: url(../src/assets/fonts/OpenSans-Regular.ttf);
}
@font-face {
  font-family: "OpenSans-Light";
  src: url(../src/assets/fonts/OpenSans-Light.ttf);
}
/*font family*/

/* tamil font size*/
.tamilLabel {
  font-size: 0.9rem;
}

.tamil-content {
  font-size: 0.8rem;
}
.tamil-first-line {
  font-size: 10rem;
}
.button-font {
  font-size: 12px !important;
}
/* tamil font size*/

@media only screen and (max-width: 500px) {
  #app {
    /* margin: 35px 5px 0 5px; */
    background: url("./assets/images/bg_first.png") no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;

    margin: 0;
    height: 100%;
  }

  form {
    padding-inline: 8%;
  }

  card {
    padding-inline: 8%;
    width: 75%;
  }
  /* social */
  .social_media_images {
    width: 70%;
  }
  /* social */
  .get-help {
    top: 82%;
    left: 77%;
  }
  .gethelp_image {
    width: 55%;
  }
  /* modal */
  .card {
    margin: 4%;
  }
  .modal-close-button {
    right: 2%;
    top: 6%;
  }
  .agree-button {
    padding-inline: 15% !important;
  }
  .reject-button {
    padding-inline: 10% !important;
  }
  /* modal */

  /*Sinhala styles */
  .sinhala-first-line {
    letter-spacing: 0.2px !important;
    color: red;
  }
}
</style>
